import KunLoading101 from './src/index'

KunLoading101.install = function (Vue) {
	Vue.component(KunLoading101.name, KunLoading101);
}

export default KunLoading101;
